import { Option } from '@mui/base';
import CropLandscapeIcon from '@mui/icons-material/CropLandscape';
import CropPortraitIcon from '@mui/icons-material/CropPortrait';
import { CustomSelect } from '../Styleguide/Common/Select';
import { HALF_INPUT_WIDTH } from '../../components/App/Content/UserDeveloper/Submission/UpdateSubmission/UpdateSubmission.types';
import { GameOrientation, GAME_ORIENTATIONS } from '@crazygames/game-types/src/game-build/orientation.type';

export const getOrientationIcon = (gameOrientation: GameOrientation) => {
  switch (gameOrientation) {
    case 'PORTRAIT':
      return <CropPortraitIcon sx={{ mr: 1 }} />;
    case 'LANDSCAPE':
      return <CropLandscapeIcon sx={{ mr: 1 }} />;
    case 'BOTH':
      return (
        <>
          <CropPortraitIcon />
          <CropLandscapeIcon sx={{ mr: 1 }} />
        </>
      );
  }
};

interface OrientationSelectorProps {
  disabled?: boolean;
  onChange: (orientation: string | null) => void;
  defaultValue: GameOrientation | null;
  error?: boolean;
  style?: React.CSSProperties;
}
const OrientationSelector = ({ disabled, defaultValue, onChange, error, style }: OrientationSelectorProps) => {
  return (
    <CustomSelect
      value={defaultValue ? defaultValue : null}
      error={error}
      disabled={disabled}
      onChange={(_e, newValue) => {
        onChange(newValue as string);
      }}
      style={{ width: HALF_INPUT_WIDTH, ...style }}
    >
      {GAME_ORIENTATIONS.map((singleGameOrientation) => {
        return (
          <Option key={singleGameOrientation} value={singleGameOrientation} style={{ alignItems: 'center', display: 'flex' }}>
            {getOrientationIcon(singleGameOrientation)}
            {singleGameOrientation}
          </Option>
        );
      })}
    </CustomSelect>
  );
};

export default OrientationSelector;
